<template>
  <div>
    <div v-if="orderDetailed && orderDetailed != null">
      <div class="px-5">
        <div v-if="isNoShow">
          <no-show-treatment-details :order="orderDetailed"></no-show-treatment-details>
        </div>
        <div v-else>
          <div v-if="treatmentsOnly && orderDetailed.treatments.length">
            <order-treatment-details
              :order="orderDetailed"
              :layout="layout"
            ></order-treatment-details>
          </div>
          <div v-if="productsOnly && orderDetailed.products.length">
            <order-product-details
              :order="orderDetailed"
              :layout="layout"
            ></order-product-details>
          </div>
        </div>

        <div v-if="terms" class="d-flex justify-content-between mt-4">
          <v-icon :color="orderDetailed.fairPayStatus === 3 ? 'red' : 'primary'" size="24px" class="mr-3">{{termsIcon || 'fxt-check'}}</v-icon>
          <div v-html="terms" class="profile__container--content__orderhistory--cancel-conditions mb-0" :class="orderDetailed.fairPayStatus === 3 ? 'red--text' : ''"></div>
        </div>
      </div>

      <slot name="actions">
          <div class="pt-4" v-if="(canCancel || canRepeatBooking || canSeeReceipt || canPayNoShow || canCancelWithFee || canAddToCalendar || goToHistoryButton || returnToProfileButton || canContactSalon || canEditAppointment)">
            <!-- RETURN TO PROFILE BUTTON -->
            <div v-if="returnToProfileButton" class="d-flex justify-center pb-4">
              <v-btn
              class="text-none px-16"
              rounded
              outlined
              color="primary"
              @click="returnToProfile()"
              >
                <div class="font-weight-bold px-2">Gå til min profil</div>
                <v-icon>fxt-user</v-icon>
              </v-btn>
            </div>

            <!-- EDIT APOINTMENT -->
            <div v-if="canEditAppointment" class="d-flex justify-center pb-4">
              <v-btn
              class="text-none"
              :class="$vuetify.breakpoint.smAndDown ? '' : 'px-16'"
              rounded
              outlined
              color="primary"
              @click="editAppointment()"
              >
                <div class="font-weight-bold px-2">Endre tid </div>
                <v-icon>fxt-pen</v-icon>
              </v-btn>
            </div>

            <!-- PAY NOSHOW BUTTON (red if REMINDER2, outlined if FEE SENT)--> 
            <div v-if="canPayNoShow" class="d-flex justify-center pb-4">
              <v-btn
              class="text-none"
              :class="[$vuetify.breakpoint.smAndDown ? '' : 'px-16', orderDetailed.fairPayStatus !== 6 ? 'white--text' : '']"
              rounded
              :outlined="orderDetailed.fairPayStatus === 6"
              :color="orderDetailed.fairPayStatus === 3 ? '#EA412A' : 'primary'"
              @click="goToPayment('noshow')"
              >
                <div class="font-weight-bold">Betal gebyr {{ orderDetailed.actualFee }} kr </div>
                <v-icon>fxt-check</v-icon>
              </v-btn>
            </div>

            <!-- CANCEL WITH FEE BUTTON -->
            <div v-if="canCancelWithFee" class="d-flex justify-center pb-4">
              <v-btn
              class="text-none"
              :class="$vuetify.breakpoint.smAndDown ? '' : 'px-16'"
              rounded
              outlined
              color="primary"
              @click="toggleCancelFeeDialog()"
              >
                <div class="font-weight-bold px-2">Avbestill mot gebyr {{ orderDetailed.actualFee.toFixed(2).replace(".", ",") }} </div>
                <v-icon>fxt-check</v-icon>
              </v-btn>
            </div>

            <!-- CANCEL BUTTON -->
            <div v-if="canCancel" class="d-flex justify-center pb-4">
                <v-btn
                class="text-none"
                text
                rounded
                color="primary"
                @click="showDialog = true"
                >
                <div class="font-weight-bold px-2">Avbestill</div>
                <v-icon>fxt-cancel</v-icon>
                </v-btn>
            </div>

            <!-- REPEAT BOOKING BUTTON -->
            <div v-if="canRepeatBooking" class="d-flex justify-center pb-4">
                <v-btn
                text
                rounded
                color="primary"
                @click="repeatOrder()"
                >
                <div class="font-weight-bold text-none pr-1">Gjenta bestilling</div>
                <v-icon>fxt-cart</v-icon>
                </v-btn>
            </div>

            <!-- ADD TO CALENDAR BUTTON -->
            <!-- TODO: -->
            <!-- <div v-if="canAddToCalendar" class="d-flex justify-center pb-4">
                <v-btn
                class="text-none"
                outlined
                rounded
                color="primary"
                @click="addToCalendar()"
                >
                <div class="font-weight-bold px-2">Legg til i kalender</div>
                <v-icon>fxt-external-link</v-icon>
                </v-btn>
            </div> -->

            <!-- GO TO HISTORY BUTTON -->
            <div v-if="goToHistoryButton" class="d-flex justify-center pb-4">
                <v-btn
                class="text-none"
                text
                rounded
                color="primary"
                @click="goToHistory()"
                >
                <div class="font-weight-bold px-2">Gå til Mine besøk og bestillinger</div>
                <v-icon>fxt-history</v-icon>
                </v-btn>
            </div>

            <!-- SHOW RECEIPT BUTTON -->
            <div v-if="canSeeReceipt" class="d-flex justify-center pb-4">
                <v-btn
                text
                rounded
                color="primary"
                @click="receiptRedirect()"
                >
                <div class="font-weight-bold text-none pr-1">Vis kvittering</div>
                <v-icon>fxt-external-link</v-icon>
                </v-btn>
            </div>

            <!-- CONTACT SALON BUTTON -->
            <div v-if="canContactSalon" class="d-flex justify-center pb-4">
              <v-btn
              class="text-none px-16"
              rounded
              text
              color="primary"
              @click="contactSalon()"
              >
                <div class="font-weight-bold px-2">Kontakt salongen</div>
                
              </v-btn>
            </div>
          </div>
      </slot>

      <common-dialog
        v-if="showDialog"
        :show="showDialog"
        :title="`Vil du avbestille timen?`"
        buttonTextConfirm="Avbestill"
        buttonColorConfirm="error"
        buttonTextColorConfirm="white"
        buttonTextCancel="Behold timen"
        @closeDialog="showDialog = false"
        @confirmAction="cancelAppointment(orderDetailed.base64AppointmentId)"
        :layout="layout"
      >
        <p>
          Timen din hos {{ orderDetailed.siteName }},
          {{ $moment(orderDetailed.appointmentDate).format("dddd D. MMMM") }} kl
          {{ $moment(orderDetailed.appointmentDate).format("HH:mm") }}, vil
          avbestilles.
        </p>
      </common-dialog>
      <common-dialog
        v-if="showCancelFeeDialog"
        :show="showCancelFeeDialog"
        :title="`Vil du avbestille timen?`"
        buttonTextConfirm="Avbestill mot gebyr"
        buttonColorConfirm="error"
        buttonTextColorConfirm="white"
        buttonTextCancel="Behold timen"
        @closeDialog="showCancelFeeDialog = false"
        @confirmAction="goToPayment('cancel')"
        :layout="layout"
      >
        <p>
          Timen din hos {{ orderDetailed.siteName }},
          {{ $moment(orderDetailed.appointmentDate).format("dddd D. MMMM") }} kl
          {{ $moment(orderDetailed.appointmentDate).format("HH:mm") }}, blir nå avbestilt. Dessverre er dette etter fristen vår, så det vil medføre et gebyr på kr {{ orderDetailed.actualFee }}.
        </p>
      </common-dialog>
      <common-dialog
        v-if="showFairPayCreateError"
        :show="showFairPayCreateError"
        :title="`Noe gikk galt`"
        icon="fxt-warning"
        buttonTextConfirm="Kontakt salongen"
        buttonColorConfirm="primary"
        buttonTextColorConfirm="white"
        buttonTextCancel="Lukk"
        @closeDialog="showFairPayCreateError = false"
        @confirmAction="contactSalon()"
        :layout="layout"
      >
        <p>
          Noe gikk galt når vi forsøkte å avbestille din time. Prøv igjen, om problemet vedvarer ta kontakt med salongen for å avbestille timen.
        </p>
      </common-dialog>
    </div>
    <div v-else>
      <v-overlay :value="loading" color="white" absolute style="height: 600px">
        <v-progress-circular
          color="var(--v-primary-base)"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import OrderTreatmentDetails from "../../OrderHistory/components/OrderTreatmentDetails.vue";
import NoShowTreatmentDetails from './NoShowTreatmentDetails.vue'
import { CommonDialog } from "../../../../Common/CommonComponents";
import OrderProductDetails from "../../OrderHistory/components/OrderProductDetails.vue";
import ProfileSvc from '../../../../../services/profile-svc';
let profileSvc = null;
export default {
  components: { OrderProductDetails, OrderTreatmentDetails, NoShowTreatmentDetails, CommonDialog },
  props: {
    layout: {
      required: false,
      default: null,
      type: String,
    },
    orderDetailed: {
      required: true
    },
    title: {
      required: true
    },
    canCancel: {
      type: Boolean
    },
    canRepeatBooking: {
      type: Boolean
    },
    canSeeReceipt: {
      type: Boolean
    },
    canAddToCalendar: {
      type: Boolean
    },
    canCancelWithFee: {
      type: Boolean
    },
    canPayNoShow: {
      type: Boolean
    },
    canContactSalon: {
      type: Boolean
    },
    canEditAppointment: {
      type: Boolean
    },
    returnToProfileButton: {
      type: Boolean
    },
    goToHistoryButton: {
      type: Boolean
    },
    isNoShow: {
      type: Boolean
    },
    treatmentsOnly: {
      type: Boolean
    },
    productsOnly: {
      type: Boolean
    },
    terms: {},
    termsIcon: {},
  },
  data: () => ({
    loading: false,
    showDialog: false,
    showCancelFeeDialog: false,
    showFairPayCreateError: false
  }),
  computed: {
    siteId() {
      return this.layout == "portal"
        ? this.$route.params.siteId
        : this.$route.query.siteId;
    },
    portalUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_URL
        : this.$config.VUE_APP_FIXIT_NO_URL
        ? this.$config.VUE_APP_FIXIT_NO_URL
        : process.env.VUE_APP_FIXIT_NO_URL;
    },
    profileUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_PROFILE_URL
        : this.$config.VUE_APP_FIXIT_PROFILE_URL
        ? this.$config.VUE_APP_FIXIT_PROFILE_URL
        : process.env.VUE_APP_FIXIT_PROFILE_URL;
    },
    bookingApi() {
        return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
    },
  },
  methods: {
    async repeatOrder() {
        let treatmentDict = []
        if (this.orderDetailed.treatments.length) {
          this.orderDetailed.treatments.forEach((x) => {
            if (!x.notBookable) {
              treatmentDict.push(x.treatmentId)
            }
          })
          if (treatmentDict.length) {
            await profileSvc.RepeatOrder(
              {
                productDict: {},
                treatmentDict: treatmentDict,
                siteId: this.orderDetailed.siteId,
                clientUuid: '' //use this?
              }
            ).then((res) => {
              if (res) {
                window.open(`${this.portalUrl}/frisor/${this.orderDetailed.urlSafeSiteName}/${this.orderDetailed.siteId}/checkout`, '_self')
              }
            })
          }
        }
    },
    editAppointment() {
      window.open(`${this.portalUrl}/frisor/${this.orderDetailed.urlSafeSiteName}/${this.orderDetailed.siteId}/endre/${this.orderDetailed.base64AppointmentId}`, '_self')
    },
    appendTreatmentsIds(order) {
      var treatmentList = order.treatments
        .map((x) => btoa(x.treatmentId))
        .join(",");
      if (treatmentList.length > 0) {
        return `treatmentIds=${treatmentList}`;
      }
      return null;
    },
    previousTreatmentUrl(order) {
    if (this.layout == "portal") {
      return `${this.portalUrl}/frisor/${this.orderDetailed.urlSafeSiteName}/${
        this.orderDetailed.siteId
      }?${this.appendTreatmentsIds(order)}`;
    } else {
      return `${this.portalUrl}/booking/${this.orderDetailed.siteId}?${this.appendTreatmentsIds(order)}`;
    }
    },
    repeatOrderOld(order) {
      window.open(this.previousTreatmentUrl(order), "_blank");
    },
    async cancelAppointment(appointmentId) {
      this.loading = true;
      if (
        await profileSvc.CancelAppointment(
          this.bookingApi,
          this.siteId.toString(),
          this.isTpn ? "True" : "False",
          appointmentId
        )
      ) {
        this.$emit('update')
        this.showDialog = false;
      }
      this.loading = false;
    },
    receiptRedirect() {
      if (this.layout == "portal") {
        window.open(
          `https://receipt.onlinetimebok.no/receipt?receiptId=${this.orderDetailed.receiptId}`,
          "_blank"
        );
      } else {
        this.$router.replace(
          `/receipt?receiptId=${this.orderDetailed.receiptId}`
        );
      }
    },
    addToCalendar() {
      
    },
    contactSalon() {
      if (this.layout === 'portal') {
        window.open(`${this.portalUrl}/frisor/${this.orderDetailed.urlSafeSiteName}/${this.orderDetailed.siteId}`, `_self`)
      } else {
        this.$router.push(`/about/${this.orderDetailed.urlSafeSiteName}`)
      }
    },
    returnToProfile() {
      if (this.layout === 'portal') {
        this.$router.push('/profil')
      } else {
        this.$router.push({query: { title: 'Profil'}})
      }
    },
    goToHistory() {
      if (this.layout === 'portal') {
        this.$router.push('/bestillinger')
      } else {
        this.$router.push({query: { title: 'bestillinger'}})
      }
    },
    toggleCancelFeeDialog() {
      this.showCancelFeeDialog = !this.showCancelFeeDialog;
    },
    toggleFairPayCreateError() {
      this.showFairPayCreateError = !this.showFairPayCreateError;
    },
    async cancelAppointmentAndCreateFairpay() {
      return await this.$store.dispatch('fairpay/cancelAppointmentAndCreate', {
          siteId: this.orderDetailed.siteId,
          id: this.orderDetailed.base64AppointmentId,
          fixitSiteId: this.orderDetailed.fixitSiteId,
          timebokBesokId: this.orderDetailed.appointmentId
      })
    },
    async goToPayment(type) {
      if (this.layout === 'portal') {
        if (type === 'cancel') {
          await this.cancelAppointmentAndCreateFairpay().then((res) => {
            this.toggleCancelFeeDialog()
            if (res) {
              this.$router.push({name: 'Valg av betalingsmetode for kansellering', params: {id: this.orderDetailed.base64AppointmentId, siteId: this.orderDetailed.siteId, order: this.orderDetailed}}) 
            } else {
              this.$emit('update')
              this.toggleFairPayCreateError()
            }
          })
        } else {
          this.$router.push({name: 'Valg av betalingsmetode', params: {id: this.orderDetailed.base64AppointmentId, siteId: this.orderDetailed.siteId, order: this.orderDetailed}})
        }
      } else {
        if (type === 'cancel') {
          await this.cancelAppointmentAndCreateFairpay().then((res) => {
            this.toggleCancelFeeDialog()
            if (res) {
              window.open(`${this.profileUrl}/sen-kansellering/${this.orderDetailed.siteId}/${this.orderDetailed.base64AppointmentId}/betaling`, `_self`)
            } else {
              this.$emit('update')
              this.toggleFairPayCreateError()
            }
          })
        } else {
          window.open(`${this.profileUrl}/ikke-mott/${this.orderDetailed.siteId}/${this.orderDetailed.base64AppointmentId}/betaling`, `_self`)
        }
      }
      },
  },
  async created() {
      profileSvc = await ProfileSvc(this.$axios);
  },
  beforeDestroy() {
    profileSvc = null
  }
}
</script>
